__turbopack_context__.v({
  "arrow": "QuickBookingRestCard-module-sass-module__4XzU1a__arrow",
  "dots": "QuickBookingRestCard-module-sass-module__4XzU1a__dots",
  "schedule": "QuickBookingRestCard-module-sass-module__4XzU1a__schedule",
  "slot": "QuickBookingRestCard-module-sass-module__4XzU1a__slot",
  "title": "QuickBookingRestCard-module-sass-module__4XzU1a__title",
  "wrapper": "QuickBookingRestCard-module-sass-module__4XzU1a__wrapper",
});
